import type { MeasurementDeviceExtendedGetModel } from '../redux/api/web-api'

import { CHARGEPOINT_MIN_CURRENT } from './electrical-settings'

export const isLoadBalancerCurrentValid = (current: number | undefined, allowZero = false): boolean =>
    current !== undefined &&
    !Number.isNaN(current) &&
    ((allowZero && current === 0) || current >= CHARGEPOINT_MIN_CURRENT)

export const isCurrentWithinSupplyLimit = (
    current?: number,
    supplyCurrent?: number,
    measurementDevice?: Pick<MeasurementDeviceExtendedGetModel, 'ignoreCurrentDirection'>
): boolean => {
    if (!measurementDevice || measurementDevice.ignoreCurrentDirection) return true
    if (current === undefined || isNaN(current)) return true
    if (supplyCurrent === undefined || isNaN(supplyCurrent)) return true
    return supplyCurrent >= current
}
